'use strict';//Indicating browser should run only in java script mode

//*******PURPOSE: THIS SERVICE IS USEFUL IN COMMUNICATING WITH THE WCF METHODS OF STICKY NOTES
//*******EFFECTIVE FILES: ../Views/StickyNotes/..
//*******CREATED BY: 
//*******CREATED DATE: 
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
angular.module('EMR.Home').service('EMRStickyNotesCommonService', ['CommonService', function (CommonService) {

	//#############   METHOD TO GET THE  STICKY NOTES COUNT  BASED ON USERBLOCK START    ##################
	//*******PURPOSE: METHOD TO GET THE  STICKY NOTES COUNT  BASED ON USER
	/// ******* CREATED BY : PHANI KUMAR 
	/// ******* CREATED DATE :23 RD MAy 2018
	//*******MODIFIED DEVELOPER : DATE - NAME - WHAT IS MODIFIED; XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
	this.StickyNoteGetStickNotesCountBasedOnUser = function (postData) {

		postData.practicemodel = EMRPracticeModel;
        return CommonService.PostData('POST', CommonService.EHRStickyNotes() + "GetStickNotesCountBasedOnUser", postData).then(
			function (result) {
				return result;
			});
	};
	//#############   METHOD TO GET THE  STICKY NOTES LIST  BASED ON USERBLOCK END    ##################

    /**
   * This methd to is Used Update the Unsigned Non Medication Orders Count
   * @author : Supraja Kapa
   * @since : 08192020
   * @param {any} isSignOff
   */
	this.StickyNotesServiceUpdateUnsignedNonMedicationOrdersCountOfUser = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
		return CommonService.PostData('POST', CommonService.EHRNonMedicationOrders() + "UpdateUnsignedNonMedicationOrdersCountOfUser", postData).then(
			function (result) {
				return result;
			});
	};

	//#region         "     REVIEWED OR NOT REVIEWED NON MEDICTION ORDERS COUNT SP CALL       "
    /**
     * @functionv StickyNotesServiceReviewNonMedicationOrdersCountOfUser()
    * @description THIS METHOD TO IS USED UPDATE THE REVIEWED OR NOT REVIEWED NON MEDICATION ORDERS COUNT
    * @author : Harish Ch
    * @since : 10/05/2020
    */
	this.StickyNotesServiceReviewNonMedicationOrdersCountOfUser = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		return CommonService.PostData('POST', CommonService.EHRNonMedicationOrders() + "NonMedicationsOrderNurseToReviewTotalCountList", postData).then(
			function (result) {
				return result;
			});
	};

}]);